import { cloneObj, compare, Module } from '@nu-art/ts-common';
import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
export const dispatch_OnInboxItemSelected = new ThunderDispatcher('__onInboxItemUpdated');
export const dispatch_OnInboxFiltersUpdated = new ThunderDispatcher('__onInboxFiltersUpdated');
/**
 * Module that handles everything selected inbox item related,
 * use this module to get or to listen on selection changes in the inbox component of the advisor
 */
class ModuleFE_Inbox_Class extends Module {
    selectedItem;
    __onAdvisorReset() {
        this.setSelectedInboxItem();
    }
    __onPathwayEndUpdated() {
        // if no protocol has ended ignore
        if (!ModuleFE_EMInterface.isPostDisposition())
            return;
        // update the component
        dispatch_OnInboxItemSelected.dispatchUI(this.selectedItem);
    }
    /**
     * Set new selected inbox item and dispatch an event that updates on the change occurred
     * @param item The new item to set as selected item.
     */
    setSelectedInboxItem = (item) => {
        if (compare(this.selectedItem, item))
            return;
        this.selectedItem = item;
        dispatch_OnInboxItemSelected.dispatchUI(item);
    };
    /**
     * Get the current value of the selected inbox item, can also be undefined
     */
    getSelectedInboxItem = () => {
        return this.selectedItem ? cloneObj(this.selectedItem) : undefined;
    };
    //Active Filters
    _activeFilters = [];
    activeFilters = {
        get: () => [...this._activeFilters],
        set: (filters) => {
            this._activeFilters = filters;
            dispatch_OnInboxFiltersUpdated.dispatchAll();
        }
    };
}
export const ModuleFE_Inbox = new ModuleFE_Inbox_Class();
//# sourceMappingURL=ModuleFE_Inbox.js.map